import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Settings, RefreshCw, AlertTriangle, ArrowLeft } from 'lucide-react';

const Mantenimiento = () => {
    const { maintenanceMode, logout } = useAuth();
    
    const handleRetry = () => {
        window.location.href = '/';
    };

    return (
        <div className="min-h-screen bg-[#0f172a] flex items-center justify-center p-6 relative overflow-hidden">
            {/* Elementos decorativos de fondo */}
            <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-blue-600/10 rounded-full blur-[120px]"></div>
            <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-indigo-600/10 rounded-full blur-[120px]"></div>
            
            <div className="max-w-2xl w-full relative">
                <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl text-center">
                    <div className="flex justify-center mb-8">
                        <div className="relative">
                            <div className="w-24 h-24 bg-gradient-to-tr from-blue-600 to-indigo-600 rounded-3xl flex items-center justify-center shadow-2xl shadow-blue-500/20 rotate-12 transition-transform hover:rotate-0 duration-500">
                                <Settings className="w-12 h-12 text-white animate-pulse" />
                            </div>
                            <div className="absolute -bottom-2 -right-2 w-10 h-10 bg-amber-500 rounded-2xl flex items-center justify-center shadow-lg border-4 border-[#1e293b]">
                                <AlertTriangle className="text-white w-5 h-5" />
                            </div>
                        </div>
                    </div>

                    <h1 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight">
                        Sistema en <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400">Mantenimiento</span>
                    </h1>

                    <div className="bg-blue-500/10 border border-blue-500/20 rounded-2xl p-6 mb-8 text-left">
                        <h2 className="text-blue-400 font-bold uppercase text-xs tracking-widest mb-2 flex items-center gap-2">
                            <span className="w-2 h-2 bg-blue-500 rounded-full animate-ping"></span>
                            Mensaje del Administrador
                        </h2>
                        <p className="text-blue-100/80 text-lg leading-relaxed italic">
                            "{maintenanceMode?.message || "Estamos realizando mejoras importantes en la plataforma para brindarte una mejor experiencia."}"
                        </p>
                    </div>

                    <p className="text-slate-400 text-lg mb-10 max-w-md mx-auto">
                        Hemos pausado temporalmente el acceso para implementar nuevas funciones. Volveremos muy pronto.
                    </p>

                    <div className="flex justify-center">
                        <button 
                            onClick={() => logout()}
                            className="w-full sm:w-auto flex items-center justify-center gap-3 py-4 px-12 bg-white/5 text-white rounded-2xl font-bold hover:bg-white/10 transition-all border border-white/10 group shadow-lg"
                        >
                            <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
                            Cerrar sesión / Volver al inicio
                        </button>
                    </div>

                    <div className="mt-12 pt-8 border-t border-white/5 flex flex-col items-center gap-4">
                        <div className="flex items-center gap-2">
                            <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                            <span className="text-slate-500 text-xs uppercase tracking-tighter font-semibold">Servidores en espera</span>
                        </div>
                        <p className="text-slate-600 text-sm">
                            &copy; 2026 IMEC - Sistema de Gestión de Cuentas
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Mantenimiento;
